/** Stable Boundary issue sentences and DOM focus targets (no React). */

/** Input id for the reporting-entity description field (focus / a11y). */
export const REPORTING_ENTITY_DESCRIPTION_FIELD_ID = 'org-reporting-entity-description';

/** Same message used by Save disable, field error, and Home missing list. */
export const REPORTING_ENTITY_DESCRIPTION_ISSUE =
  'Describe the reporting entity (at least a company name and the sites in the inventory).';

export const REPORTING_ENTITY_DESCRIPTION_MIN_LENGTH = 12;

/** Stable issue sentences — single source with organizationalBoundaryIssues(). */
export const ORG_BOUNDARY_ISSUE = {
  consolidation:
    'Select a consolidation approach (operational control, financial control, or equity share).',
  reportingEntity: REPORTING_ENTITY_DESCRIPTION_ISSUE,
  jvAllocation: 'Choose how joint-venture emissions are allocated.',
  franchises:
    'State how franchises or outsourced operations are treated. Enter None if there are none.',
  singleOrRelated:
    'Confirm this is a single legal entity, or add the holding company, a subsidiary, or a joint venture.',
  fuel:
    'Say whether this company burns fuel in equipment it operates. That decides Scope 1 versus contractor Scope 3.',
  fleet: 'Say whether the company operates its own vehicles.',
  logistics: 'Say whether goods move on company vehicles, contractor vehicles, or both.',
  equityPercent: 'Equity share needs the percent of emissions this company counts (1 to 100).',
} as const;

/** Prefix for dynamic ownership-percent issues (name appended). */
export const ORG_BOUNDARY_OWNERSHIP_ISSUE_PREFIX =
  'Equity share requires an ownership percent for ';

/** Stable DOM ids / data-testid values for click-to-focus targets. */
export const ORG_BOUNDARY_FOCUS = {
  consolidation: 'org-boundary-consolidation',
  sites: 'org-boundary-sites',
  reportingEntityGroup: 'org-boundary-reporting-entity',
  reportingEntity: REPORTING_ENTITY_DESCRIPTION_FIELD_ID,
  relatedParties: 'org-boundary-related-parties',
  singleLegalEntity: 'org-boundary-single-legal-entity',
  holding: 'org-boundary-holding',
  subsidiaries: 'org-boundary-subsidiaries',
  jointVentures: 'org-boundary-joint-ventures',
  jvAllocation: 'org-boundary-jv-allocation',
  franchises: 'org-boundary-franchises',
  fuel: 'org-boundary-fuel',
  fleet: 'org-boundary-fleet',
  logistics: 'org-boundary-logistics',
  equityPercent: 'org-equity-percent',
  relatedOwnership: 'org-boundary-related-ownership',
} as const;

/** Opens the Boundaries editor accordion when focus targets are not yet mounted. */
export const OPEN_BOUNDARIES_EDITOR_EVENT = 'ci-open-boundaries-editor';
